export const AccessControlReport = {
  selectedCamerasAreNotSetUp:
    "The selected cameras are not set up to detect entries and/or exits.",
  pleaseSelectAReport: "Please select a report.",
  pleaseAddOneOrMoreAssets: "Please add one or more assets.",
  noReportsHaveBeenCreated: "No reports have been created.",
  maximumImagesPerHour: "Maximum images per hour",
  selectOneOrMoreClasses: "Select one or more classes",
  detectionType: "Detection type",
  detectionTypeOptions: {
    entry: "Entry",
    exit: "Exit",
    both: "Entry and Exit",
  },
  changes: "Changes",
  showingDetections: (value: number | string, total: number | string) =>
    `Showing ${value} of ${total} detections.`,
};
